// blog20.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "../allcss/blog18.css";
import blogImage from "../Asets/Blog.jpg"; // hero background
import detailImg from "../Asets/blog2020.png"; // detail image (update if needed)
import Header from "../components/header";
import Footer from "../components/footer";

const Blog20 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: "pointer", color: "#fff" }}
                onClick={() => navigate("/")}
              >
                Home
              </span>
              <span> / Our Blog / Creativity & Confidence</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            How Red School House Encourages Creativity and Confidence in Young Learners
          </h2>
          <br />
          <div className="published-badge">Published on: 7 November 2025</div>
          <br />

          <img
            src={detailImg}
            alt="Red School House Vadodara - nurturing creativity and confidence"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">
            <p>
              Every child is born curious — eager to explore, imagine, and express.
              At <strong>Red School House Vadodara</strong>, we believe that nurturing
              creativity and confidence in the early years builds the foundation
              for lifelong success. Our preschool isn’t just about learning letters
              and numbers; it’s about helping children discover who they are, think
              freely, and believe in themselves. Through our play-based learning
              environment, we empower young minds to explore new ideas, make
              mistakes fearlessly, and develop the confidence to try again.
            </p>

            <h3>A Learning Environment that Inspires Creativity</h3>
            <p>
              At Red School House, every classroom is designed to spark imagination.
              Bright colours, engaging visuals, and hands-on materials invite children
              to learn through play, art, and exploration. Our teachers use activities
              like storytelling, drawing, role play, and music to encourage children to
              express themselves in multiple ways. Whether a child paints, sings, or
              builds — each activity helps them understand the world creatively.
            </p>
            <p>
              We believe creative expression isn’t limited to art; it’s a mindset that
              fosters problem-solving, curiosity, and innovation from an early age.
            </p>

            <h3>Encouraging Confidence Through Positive Learning</h3>
            <p>
              Confidence grows when children feel heard, valued, and supported.
              We create a positive atmosphere where every child’s voice matters.
              Teachers guide gently, praise effort, and celebrate every achievement —
              big or small. Group activities and performances allow children to share
              ideas in front of others, boosting self-esteem. Over time, they learn
              that mistakes are part of growth — a lesson that keeps them motivated
              for life.
            </p>

            <h3>Our Approach to Creative Learning</h3>
            <p>We follow an activity-based, experiential approach that blends fun with skill-building:</p>
            <ul>
              <li>🎨 <strong>Art & Craft:</strong> Visual expression and fine-motor development.</li>
              <li>🎵 <strong>Music & Dance:</strong> Rhythm, coordination, and emotional expression.</li>
              <li>📖 <strong>Storytelling & Role Play:</strong> Imagination, language, and empathy.</li>
              <li>🧩 <strong>Games & Puzzles:</strong> Problem-solving and teamwork.</li>
              <li>🌱 <strong>Outdoor Play:</strong> Nature-inspired curiosity and observation.</li>
            </ul>
            <p>
              This balanced mix keeps children engaged, joyful, and confident in their
              ability to learn and create.
            </p>

            <h3>The Role of Teachers in Nurturing Confidence</h3>
            <p>
              Our teachers don’t just instruct — they inspire. Every child receives
              personal attention and encouragement, ensuring they feel safe to explore
              and express themselves. By observing each child’s unique interests,
              teachers design activities that match their pace and personality. This
              personalised approach helps children build self-assurance and a positive
              attitude toward learning.
            </p>

            <h3>Parent Involvement: The Key to Growth</h3>
            <p>
              Education works best when parents and teachers collaborate. We keep
              parents informed about progress through regular updates and events.
              When children see their families engaged in their learning journey,
              it further boosts their confidence and motivation.
            </p>

            <h3>Conclusion</h3>
            <p>
              Creativity and confidence are the wings every child needs to fly.
              At <strong>Red School House Vadodara</strong>, we nurture both —
              helping children grow into independent thinkers, problem solvers,
              and dreamers. Through love, encouragement, and playful learning, we
              give every child the chance to shine brightly and believe in their
              own potential. If you’re looking for a preschool in Vadodara that
              celebrates creativity and builds lifelong confidence, Red School House
              Vadodara is your perfect choice.
            </p>

            <h3>Contact Details</h3>
            <p>
              📍 <strong>Address:</strong> A-25, Castle White, Opp. Main Harni Water Tank,
              Harni Sama Link Road, Vadodara – 390008
              <br />
              📞 <strong>Phone:</strong> <a href="tel:+917778851070">+91 77788 51070</a>
              <br />
              📧 <strong>Email:</strong>{" "}
              <a href="mailto:redschoolhousebaroda2025@gmail.com">redschoolhousebaroda2025@gmail.com</a>{" "}
              | <a href="mailto:redschoolhousebaroda@gmail.com">redschoolhousebaroda@gmail.com</a>
              <br />
              🌐 <strong>Website:</strong>{" "}
              <a
                href="https://redhouseschoolvadodara.in/"
                target="_blank"
                rel="noreferrer"
              >
                redhouseschoolvadodara.in
              </a>
            </p>

            {/* Go Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate("/blog")}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog20;
